export default __webpack_public_path__ + "static/ryon-a7d822dfbc957b0d53a8decce7cfc743.jpg";